import React, { useState } from "react";
import ClientInfoModal from "../Modals/ClientInfoModal";
import { getTwoLetters } from "utils/utils";
import { useNavigate } from "react-router-dom";

interface ClientBasicInfoProps {
  client: {
    id: number;
    name: string;
    company_name: string;
    phone: string;
    email: string;
    address: string;
    city: string | null;
    postcode: string | null;
    country: string | null;
    total_invoices: number;
    total_quotes: number;
    total_invoices_amount: number;
    total_quotes_amount: number;
    recent_activities: any[];
    created_at: string;
    updated_at: string;
  };
}

const ClientBasicInfo: React.FC<ClientBasicInfoProps> = ({ client }) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <div className="d-flex flex-column p-3 bg-white br-10">
      <ClientInfoModal
        isOpen={showModal}
        onClose={closeModal}
        client={client}
        onViewProfileClick={() => {
          navigate("/client-details", {
            state: { id: client.id },
          });
        }}
      />
      <div className="d-flex justify-content-between align-items-center gap-5">
        <div className="fw-medium fs-16 text-black2D font-primary">
          Client Details
        </div>
        <div
          className="fw-normal fs-12 text-primary font-primary"
          onClick={openModal}
          style={{ cursor: "pointer" }}
        >
          View Info &gt;
        </div>
      </div>

      {/* Border */}
      <div className="border-bottom my-3 mx-n4"></div>

      <div className="d-flex align-items-center gap-3">
        <div
          style={{
            width: 38,
            height: 38,
            minWidth: 38,
            minHeight: 38,
            borderRadius: 7,
            backgroundColor: "#ECF0FE",
            display: "grid",
            placeItems: "center",
            flexShrink: 0,
          }}
        >
          <div className="fw-medium fs-14 text-blue466 font-primary">
            {getTwoLetters(client.name)}
          </div>
        </div>
        <div>
          <div
            className="fw-medium fs-16 text-black2D "
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            }}
          >
            {client.name}
          </div>
          <div
            className="fw-normal fs-14 text-grey89"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            }}
          >
            {client.company_name}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ClientBasicInfo);
